import { render, staticRenderFns } from "./CtaBannerModule.vue?vue&type=template&id=4c80acdc"
import script from "./CtaBannerModule.vue?vue&type=script&lang=js"
export * from "./CtaBannerModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports